import { lazy } from 'react';

export const ServicePageLazy = lazy(() =>
  import('./service-page').then(m => ({ default: m.ServicePage }))
);
